// Server URL's
export let IMG_URL;
export let API_URL;

// Set URL's on production or development
if (process.env.NODE_ENV === 'production') {
   IMG_URL = 'https://api.expomedica.mx';
   API_URL = 'https://api.expomedica.mx';
} else {
   IMG_URL = 'http://localhost:8081';
   API_URL = 'http://localhost:8081';
}



// WEBPACK FOOTER //
// ./src/config/apiURL.js